// ✅ Componente React — WellnessVsCargaRanking.jsx
// Insertar en la vista general del Panel del Entrenador (overview de todos
// los atletas), debajo del PMC multi-atleta existente.
import { useEffect, useState } from 'react';
import API_BASE_URL from '../../../config/api';

const ESTADO_LABEL = {
  alerta: { texto: 'Divergen', bg: '#fcebeb', color: '#a32d2d', barra: '#dc2626' },
  vigilar: { texto: 'Vigilar', bg: '#faeeda', color: '#854f0b', barra: '#d97706' },
  ok: { texto: 'Coinciden', bg: '#eaf3de', color: '#3b6d11', barra: '#16a34a' },
  sin_datos: { texto: 'Sin datos', bg: '#f1f5f9', color: '#64748b', barra: '#94a3b8' },
};

const initials = (name = '') =>
  name
    .split(' ')
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

/**
 * trainerId: id del entrenador autenticado
 * onSelectAthlete: callback(athleteId) — para navegar al detalle del atleta
 *   al hacer click en una fila (mismo patron que selectAthlete del mockup)
 */
const WellnessVsCargaRanking = ({ trainerId, onSelectAthlete }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!trainerId) return;
    fetch(`${API_BASE_URL}/api/wellness-vs-carga/ranking/${trainerId}`)
      .then((res) => res.json())
      .then(setRows)
      .finally(() => setLoading(false));
  }, [trainerId]);

  return (
    <div className="td-card" style={{ padding: '10px 12px', marginTop: '8px' }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#193255', marginBottom: 2 }}>
        🧬 Ranking Wellness vs Carga
      </div>
      <div style={{ fontSize: 9, color: '#94a3b8', marginBottom: 8 }}>
        Atletas ordenados de mayor a menor divergencia entre el modelo y la sensación — los
        primeros necesitan revisión
      </div>

      {loading ? (
        <div style={{ fontSize: 11, color: '#94a3b8', padding: '10px 0', textAlign: 'center' }}>
          Cargando…
        </div>
      ) : (
        rows.map((r, i) => {
          const info = ESTADO_LABEL[r.estado] || ESTADO_LABEL.ok;
          const isAlert = r.estado === 'alerta';
          return (
            <div
              key={r.athleteId}
              onClick={() => onSelectAthlete && onSelectAthlete(r.athleteId)}
              style={{
                border: isAlert ? '1px solid #f7c1c1' : '1px solid #e6e9ef',
                background: isAlert ? '#fff8f8' : '#fff',
                borderRadius: 8,
                padding: '10px 12px',
                marginBottom: 8,
                cursor: 'pointer',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{ fontSize: 10, color: '#94a3b8', width: 14, flexShrink: 0 }}>
                  {i + 1}
                </span>
                <div className="pmc-av" style={{ background: '#193255' }}>
                  {initials(r.name)}
                </div>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#193255', flex: 1 }}>
                  {r.name}
                </div>
                <span
                  style={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: info.color,
                    background: info.bg,
                    padding: '2px 9px',
                    borderRadius: 6,
                  }}
                >
                  {info.texto}
                </span>
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(4,1fr)',
                  gap: 6,
                  fontSize: 10,
                }}
              >
                <div>
                  <span style={{ color: '#94a3b8' }}>TSB hoy</span>
                  <br />
                  <span style={{ fontWeight: 700, fontSize: 12, color: '#193255' }}>
                    {r.tsbHoy ?? '—'}
                  </span>
                </div>
                <div>
                  <span style={{ color: '#94a3b8' }}>Wellness PRE</span>
                  <br />
                  <span style={{ fontWeight: 700, fontSize: 12, color: '#193255' }}>
                    {r.wellnessPre != null ? `${r.wellnessPre}/25` : '—'}
                  </span>
                </div>
                <div>
                  <span style={{ color: '#94a3b8' }}>Delta sesión</span>
                  <br />
                  <span style={{ fontWeight: 700, fontSize: 12, color: info.barra }}>
                    {r.deltaSesion ?? '—'}
                  </span>
                </div>
                <div>
                  <span style={{ color: '#94a3b8' }}>Tendencia 4 sem</span>
                  <br />
                  <span style={{ fontWeight: 700, fontSize: 12, color: info.barra }}>
                    {r.tendenciaInicio ?? '—'} → {r.tendenciaFin ?? '—'}
                  </span>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default WellnessVsCargaRanking;
